import { useState } from 'react';
import { Container } from './styles';
import { SummaryAccordionContent } from './SummaryAccordionContent';
import { SummaryAccordionHeader } from './SummaryAccordionHeader';
import { AccordionContext } from '../../../../hooks/ui_hooks/useAccordionContext';

export const SummaryAccordion = ({ shouldStartOpened, children, ...restProps }) => {
  const [expanded, setExpanded] = useState(shouldStartOpened);

  return (
    <AccordionContext.Provider value={{ expanded, setExpanded }}>
      <Container {...restProps}>{children}</Container>
    </AccordionContext.Provider>
  );
};

SummaryAccordion.Content = SummaryAccordionContent;

SummaryAccordion.Header = SummaryAccordionHeader;
